import * as OM from '@/model';

class _StorageServices  {
    
    private readFromLocalStorage<T>(lsName: string): T | null {
        let data = window.localStorage.getItem(lsName);
        if(data){
            return JSON.parse(data);
        } else {
            return null;
        }
    }
    
    setOpTableFilters(key: string, filters: any){
        window.localStorage.setItem('_op_' + key, JSON.stringify(filters));
    }
    getOpTableFilters(key: string){
        return this.readFromLocalStorage<any>('_op_' + key);
    }
    setOpTablePage(key: string, pageNumber: number){
        window.localStorage.setItem('_op_page_' + key, JSON.stringify(pageNumber));
    }
    getOpTablePage(key: string){
        return this.readFromLocalStorage<number>('_op_page_' + key);
    }
    setOpTablePerPage(key: string, perPageNumber: number){
        window.localStorage.setItem('_op_perpage_' + key, JSON.stringify(perPageNumber));
    }
    getOpTablePerPage(key: string){
        return this.readFromLocalStorage<number>('_op_perpage_' + key);
    }

    getLoginResponse() {
        return this.readFromLocalStorage<OM.LoginResponse>('LoginResponse');
    }
    setLoginResponse(response: OM.LoginResponse) {
        window.localStorage.setItem('LoginResponse', JSON.stringify(response));
    }
    
}

export let StorageServices = new _StorageServices();